module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-template __donate __uob"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container pd-sm-0"
  }, [_c('div', {
    staticClass: "col-md-push-1 col-md-10 col-lg-push-1 col-md-10"
  }, [_c('h1', {
    staticClass: "page-title text-center"
  }, [_vm._v("ร่วมบริจาค")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "product product--inline"
  }, [_c('div', {
    staticClass: "product__block--form"
  }, [_c('div', {
    staticClass: "radius block shadow"
  }, [_c('product-donate-choice', {
    ref: "donateChoice",
    attrs: {
      "show-donate-type": true,
      "product": _vm.product,
      "classes": "col-1-5"
    },
    model: {
      value: (_vm.product.price),
      callback: function($$v) {
        _vm.$set(_vm.product, "price", $$v)
      },
      expression: "product.price"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "pt-15"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "form__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigChoice),
      expression: "attributes.info.rewardConfigChoice"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.attributes.info, "rewardConfigChoice", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- โปรดระบุตำแหน่ง --")]), _vm._v(" "), _vm._l((_vm.LevelOptions), function(LevelOption) {
    return _c('option', {
      key: LevelOption.text,
      domProps: {
        "value": LevelOption.description
      }
    }, [_vm._v("\n                              " + _vm._s(LevelOption.description) + "\n                              ")])
  })], 2)]), _vm._v(" "), (_vm.error.rewardConfigChoice) ? _c('div', {
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาระบุตำแหน่ง")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "pt-15"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attributes.info.rewardConfigText),
      expression: "attributes.info.rewardConfigText"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.attributes.info, "rewardConfigText", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- โปรดระบุหน่วยงาน --")]), _vm._v(" "), _vm._l((_vm.FunctionOptions), function(FunctionOption) {
    return _c('option', {
      key: FunctionOption.text,
      domProps: {
        "value": FunctionOption.description
      }
    }, [_vm._v("\n                              " + _vm._s(FunctionOption.description) + "\n                              ")])
  })], 2)]), _vm._v(" "), (_vm.error.rewardConfigText) ? _c('div', {
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาระบุหน่วยงานของท่าน")]) : _vm._e()])])]), _vm._v(" "), _c('page-selector', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "product": _vm.product
    },
    model: {
      value: (_vm.attributes.page),
      callback: function($$v) {
        _vm.$set(_vm.attributes, "page", $$v)
      },
      expression: "attributes.page"
    }
  }), _vm._v(" "), _c('product-cart-action', {
    ref: "cartAction",
    style: ({
      margin: 0
    }),
    attrs: {
      "product": _vm.product,
      "attributes": _vm.attributes,
      "initialQuantity": 1,
      "addToCartButton": false,
      "buyNowButton": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn--purple btn--default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.donate.apply(null, arguments)
      }
    }
  }, [_vm._v("บริจาค")])])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper-header"
  }, [_c('div', {
    staticClass: "col-md-push-3 col-md-6"
  }, [_c('h1', {
    staticClass: "text-center mb-20 mt-30",
    attrs: {
      "data-v-1f20e9ef": ""
    }
  }, [_c('img', {
    staticClass: "pd-15 ma-auto d-block",
    staticStyle: {
      "width": "100%",
      "max-width": "450px"
    },
    attrs: {
      "src": "/static/img/uob/logo-uobxtcfexffg@2x.png",
      "srcset": "/static/img/uob/logo-uobxtcfexffg@2x.png",
      "alt": "UOB X TCFE x FoodForGood"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "text-center"
  }, [_vm._v("โครงการ 2022 UOB Global Heartbeat Run/Walk"), _c('br'), _vm._v("ชวนคุณร่วมเป็น "), _c('strong', [_vm._v("“ผู้ให้”")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('strong', [_vm._v("ระบุตำแหน่ง "), _c('span', {
    staticStyle: {
      "color": "#E82B27"
    }
  }, [_vm._v("*")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('strong', [_vm._v("ระบุหน่วยงานของท่าน "), _c('span', {
    staticStyle: {
      "color": "#E82B27"
    }
  }, [_vm._v("*")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c17b3f0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/products/uob-default.vue
// module id = 1135
// module chunks = 0